import BaseModel from '../base.js';
class OrgModel extends BaseModel {
  //获取单个组织信息
  async getDetail(orgId) {
    const {err, res} = await this.$ajax.get(this.$apiUrl.ORG.GET, {orgId});
    return {err, res};
  }
}
export default OrgModel;

// ./src/model/modules/org/index.js



// WEBPACK FOOTER //
// ./src/model/modules/org/index.js